import { Apartment } from 'types/Apartment';
import { Cooperative } from 'types/Cooperative';

const getApartmentName = (apartment: Apartment, viewType: Cooperative['apartment_display']) => apartment[viewType];

export default getApartmentName;
